import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import { useGET_groupCourseSessionByIdQuery } from 'redux/api/sessionsApi'
import { crudActionsMap } from 'utils/helpers'
import UnitForm from 'components/organisms/forms/UnitForm'

const UnitCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const [searchParams] = useSearchParams();
  
  const id = params?.id

  const course_id = searchParams.get('course_id')
  const course_title = searchParams.get('course_title')
  const grade_level = searchParams.get('grade_level')

  const user = useSelector((state: RootState) => state['user'].user)

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = user?.role === 'special_teacher' || action === 'view' || action === 'delete'

  return ( <>
        <PageHeading title={`${t('goalbank.units')} / ${t('common.' + action)}`} />

        <PageBody>
          <UnitForm 
            action={action} 
            id={id} 
            initial_course_id={course_id} 
            initial_course_title={course_title}
            initial_grade_level={grade_level} 
            viewOnly={viewOnly} />
        </PageBody> 
      </> 
    
  )
}
export default UnitCrudPage

